import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// "ResizeObserver loop completed with undelivered notifications" / "loop limit
// exceeded" is a benign browser notification (it self-recovers on the next frame),
// but CRA's dev error overlay surfaces it as an uncaught runtime error. Swallow
// ONLY this exact message so it can't mask real errors. No-op in production (the
// overlay doesn't run there). App-code observers are also rAF-debounced at source.
const RESIZE_OBSERVER_ERR =
  /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener('error', (e) => {
  if (e.message && RESIZE_OBSERVER_ERR.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
